@if (!printViewShown) {
    <elem-button
        buttonRole="SECONDARY"
        icon="icon-print"
        (click)="open(true)">{{ buttonText ? buttonText : 'Drucken' }}
    </elem-button>
}
